import React, { useState, useEffect } from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import IconSocial from '~/components/atoms/IconSocial';

export default function StoryPreview({ className, iconsClassName, headingType = 'h5', headingClassName ='', headingText = 'Share post:' }) {
  const [pageUrl, setPageUrl] = useState('');
  useEffect(() => {
    setPageUrl(window?.location?.href);
  }, []);

  const HeadingTag = headingType && headingType.substr(0, 1) === "h" ? headingType : "h2";

  return (
    <div className={`flex flex-col md:flex-row items-center justify-center ${className}`}>
      <HeadingTag className={`text-${HeadingTag} mb-5 md:mb-0  md:mr-5 ${headingClassName}`}>{headingText}</HeadingTag>
      <div className={`flex items-center space-x-3 ${iconsClassName}`}>
        <FacebookShareButton url={pageUrl}>
          <div className="w-12 h-12 border border-navy border-opacity-10 rounded-full flex items-center justify-center bg-transprent hover:bg-navy transition-colors duration-200 ease-in-out group">
            <IconSocial className="w-4 h-auto group-hover:text-white" />
          </div>
        </FacebookShareButton>
        <TwitterShareButton url={pageUrl}>
          <div className="w-12 h-12 border border-navy border-opacity-10 rounded-full flex items-center justify-center bg-transprent hover:bg-navy transition-colors duration-200 ease-in-out group">
            <IconSocial className="w-4 h-auto group-hover:text-white" type="twitter" />
          </div>
        </TwitterShareButton>
        <LinkedinShareButton url={pageUrl}>
          <div className="w-12 h-12 border border-navy border-opacity-10 rounded-full flex items-center justify-center bg-transprent hover:bg-navy transition-colors duration-200 ease-in-out group">
            <IconSocial className="w-4 h-auto group-hover:text-white" type="linkedin" />
          </div>
        </LinkedinShareButton>
        <WhatsappShareButton url={pageUrl}>
          <div className="w-12 h-12 border border-navy border-opacity-10 rounded-full flex items-center justify-center bg-transprent hover:bg-navy transition-colors duration-200 ease-in-out group">
            <IconSocial className="w-4 h-auto group-hover:text-white" type="whatsapp" />
          </div>
        </WhatsappShareButton>
        <EmailShareButton url={pageUrl}>
          <div className="w-12 h-12 border border-navy border-opacity-10 rounded-full flex items-center justify-center bg-transprent hover:bg-navy transition-colors duration-200 ease-in-out group">
            <IconSocial className="w-4 h-auto group-hover:text-white" type="email" />
          </div>
        </EmailShareButton>
      </div>
    </div>
  );
}
